export default __webpack_public_path__ + "static/media/the-rotation-blk.22dd9692.png";